import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMotorVehicleStart,
  getMotorVehicleSuccess,
  getMotorVehicleFailure,
} from "../reducers/getMotorVehicleReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";
export const getMotorVehicle = createAsyncThunk(
  "getMotorVehicle",
  async ({ e, productId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(getMotorVehicleStart());
      const token = Cookies.get("token");
      const params = {
        Product_ID: productId,
        MakeCode: e,
      };
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Motor/GetVehicle`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getMotorVehicleSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getMotorVehicleFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);